import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
import "tachyons";
import App from './App';
import { Provider } from 'react-redux';
import store from './redux/CreateStore';


// ReactDOM.render(
//   <React.StrictMode>
//     <App/>
//   </React.StrictMode>,
//   document.getElementById('root')
// );

ReactDOM.render(
  // <React.StrictMode>
  <Provider store={store}>
    <App />
  </Provider>,
  // </React.StrictMode>,
  document.getElementById('root')
);

const registerServiceWorker = async () => {
  if (navigator.serviceWorker) {
    try {
      const registration = await navigator.serviceWorker.register("./serviceworker.js", { scope: '/' });
      if (registration.installing) {
        console.log("service worker installing");
      } else if (registration.waiting) { //not sure about this yet
        console.log("service worker waiting");
      } else if (registration.activating) { //not sure about this yet
        console.log("service worker activating");
      } else if (registration.active) {
        console.log("service worker active");
      } else {
        console.log("final else case in service worker register scenario v4 test");
      }
    } catch (error) {
      console.error("Error at service worker registraton:", error);
    }
  }
}
// // Override Text scaling
// if (Text.defaultProps) {
//   Text.defaultProps.allowFontScaling = false;
// } else {
//   Text.defaultProps = {};
//   Text.defaultProps.allowFontScaling = false;
// }

// window.addEventListener('resize', function(event) {
//   console.log("pk window resize called")
// }, true);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
// registerServiceWorker();

